// @ts-ignore: TODO: fix the msp-components missing module declaration
import { CommerceBoxProductProps } from 'msp-components'

const validateProduct = (
  product?: CommerceBoxProductProps | string,
  noVariants: boolean = false
) => {
  if (!product) return {}
  if (typeof product === 'string') return product
  if (product && noVariants) return product

  const {
    id,
    price,
    currency,
    c_inventory,
    stepQuantity,
    primaryCategoryId,
    slugUrl,
    minOrderQuantity
  } = product || {}
  if (
    id &&
    price &&
    currency &&
    c_inventory &&
    stepQuantity &&
    primaryCategoryId &&
    slugUrl &&
    minOrderQuantity
  ) {
    return product || {}
  }
  // If we've some missing information, we'll do the call anyway
  return id
}

export { validateProduct }
